import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "badge bg-danger text-white"
}


const __default__ = {
    name: "BuddyListChannelButton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    descr: {},
    selected: { type: Boolean },
    unreadedCount: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



let emits = __emit;

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_component_el_button, {
    round: "",
    size: "small",
    type: "info",
    plain: !__props.selected,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click'))),
    class: "button ml-0 mr-1 p-1 pl-2 pr-2 mt-1"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.descr) + " ", 1),
      (__props.unreadedCount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.unreadedCount), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["plain"]))
}
}

})